<template>
  <div
    class="ToolTip"
    @click.stop
    @mouseover="ui.showElement = true"
    @mouseout="ui.showElement = false"
  >
    <slot name="trigger">
      <span class="far fa-ellipsis-h" />
    </slot>
    <transition name="slide-fade">
      <div
        v-if="ui.showElement"
        :class="['Tooltip-content', position]"
      >
        <slot name="tip">
          <p>Tip</p>
        </slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    position: {
      type: String,
      default: 'top center',
    },
  },

  data() {
    return {
      ui: {
        showElement: false,
      },
    };
  },
};
</script>
<style lang="scss" scoped>
@import '../../../scss/abstracts/abstracts.scss';

.slide-fade-enter-active {
  transition: all .3s ease;
}

.slide-fade-leave-active {
  transition: all .2s ease;
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateY(-20px) scale(0);
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-20px) scale(0);
}

.Tooltip-content {
  width: auto;
  position: absolute;
  min-width: 150px;
  bottom: 100%;
  border-radius: 6px;
  color: color('white');
  padding: 8px;
  font-size: 14px;
  background: rgba(0, 0, 0, 0.8);
}

/* POSITIONING */
.center {
  left: 50%;
  transform: translateX(-50%);
}

.top {
  bottom: 100%;
}

.bottom {
  top: 100%;
}

.left {
  left: 0;
}

.right {
  right: 0;
}

.ToolTip {
  display: inline-block;
  position: relative;
}
</style>
